import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const SahBudgetsState = (state: RootState) => state.supportAtHome.sahBudgets;

export const selectSahBudgets = (state: RootState) => SahBudgetsState(state).rows;
export const selectSahBudgetsByClient = (state: RootState) => SahBudgetsState(state).clientRows;
export const selectSahConnected = (state: RootState) => SahBudgetsState(state).saConnected;

export const selectLoading = (state: RootState) => SahBudgetsState(state).loading;
export const selectErrorResponse = (state: RootState) => SahBudgetsState(state).error;
export const selectUploadError = (state: RootState) => SahBudgetsState(state).uploadError;

// lookups
export const lookupSahBudgets = createSelector([selectSahBudgets], (row) =>
  row.map(({ id, sah_budget_id }) => ({
    value: id,
    label: `${sah_budget_id}`,
  })),
);
